import { format } from 'date-fns';
import { Component, OnInit } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  ValidatorFn,
  ValidationErrors,
  Validators,
  AbstractControl,
} from "@angular/forms";
import { Router } from "@angular/router";
import { AngularCsv } from "angular-csv-ext/dist/Angular-csv";
import { NzModalService } from "ng-zorro-antd/modal";
import { Modules, Responsibility } from "shared/models";
import {
  AddNotificationGroups,
  NotificationGroups,
  NotificationGroupsModelExport,
  NotificationReportScheduleMapping,
  WhatsAppTemplateList,
  NotificationGroupDetails,
  NotificationReportScheduleMappingDetails,
  BroadcastPushNotificationRequest,
  PushEnabledUser,
} from "shared/models";
import { AlertMessageService } from "shared/core";
import { AuthService } from "shared/core";
import { LoggingService } from "shared/core";
import { environment } from "src/environments/environment";
import { UserModel } from "shared/models";
import { CustomerModel } from "shared/models";
import { LoadingService } from "shared/core";
import { MobileValidationService } from "src/PmsUIApp/Services/mobile-validation.service";
import * as cronstrue from 'cronstrue';
import { debounceTime, tap, shareReplay } from "rxjs/operators";
import { Observable } from "rxjs";

@Component({
    selector: "app-notification-group",
    templateUrl: "./notification-group.component.html",
    styleUrls: ["./notification-group.component.css"],
    standalone: false
})
export class NotificationGroupComponent implements OnInit {
  WhatsAppTemplateList: WhatsAppTemplateList[];
  constructor(
    public http: HttpClient,
    private alertService: AlertMessageService,
    private modalService: NzModalService,
    private auth: AuthService,
    private router: Router,
    private fb: UntypedFormBuilder,
    private loader: LoadingService,
    private logger: LoggingService,
    private mobileValidationService: MobileValidationService
  ) { this.createForm() }

  permission = {
    View: false,
    Add: false,
    Edit: false,
    Delete: false,
  };

  ApiUrl = environment.Api_Url;
  validateForm!: UntypedFormGroup;

  PopUpTitle: string = "Add New Notification Group";
  searchValue = "";
  IsSearching = false;
  isTableLoading: boolean = false;
  isVisible = false;
  isLoading: boolean = false;
  isShownEdit: boolean = false;
  NotificationTitle: string = "";

  // New properties for drawer view
  isViewDrawerVisible = false;
  viewDrawerTitle = "";
  selectedNotificationGroup: NotificationGroups = null;
  selectedNotificationGroupDetails: NotificationGroupDetails = null;
  isLoadingDetails = false;

  // Broadcast push notification properties
  isBroadcastModalVisible = false;
  isSendingBroadcast = false;
  broadcastRequest: BroadcastPushNotificationRequest = new BroadcastPushNotificationRequest();
  pushEnabledUsers: PushEnabledUser[] = [];
  count_broadcast = 0;
  messageTypeOptions = [
    { label: 'Alert', value: 'Alert' },
    { label: 'Announcement', value: 'Announcement' },
    { label: 'News', value: 'News' }
  ];
  priorityOptions = [
    { label: 'Normal', value: 'normal' },
    { label: 'High', value: 'high' },
    { label: 'Critical', value: 'critical' }
  ];

  NotificationGroupList: NotificationGroups[] = [];
  NotificationGroupListOriginal: NotificationGroups[] = [];
  AddNotificationGroups: NotificationGroups = new NotificationGroups();

  selectedUser: "";
  selectedCustomer: "";

  NotificationGroupListExport: NotificationGroupsModelExport[] = [];
  exportfields: NotificationGroupsModelExport[] = [];
  exportoptions = {
    headers: [
      "Notification Type",
      "Trigger Type",
      "Report Name",
      "User Type",
      "Name",
      "Email",
      "Mobile Number",
      "Is WhatsApp Notification Enabled",
      "Enable To Email",
      "Enable Cc Email",
      "Enable Bcc Email",
    ],
  };

  fields: NotificationGroupsModelExport = new NotificationGroupsModelExport();
  count: number;

  // =====================================================
  // HIERARCHICAL DROPDOWN DATA - Based on Configuration API
  // =====================================================

  // Master configuration data from API
  NotificationConfigurationList: any[] = [];

  // Hierarchical dropdown selections (8-level sequence)
  SelectedCategoryType: string = "";           // Level 1: Filter only, not saved
  SelectedNotificationType: string = "";       // Level 2: Cascading from Category
  SelectedReportType: string = "";             // Level 3: SubType for Reports
  SelectedTriggerTypes: string[] = [];         // Level 4: Based on configuration capabilities
  SelectedCronExpression: string = "";         // Level 5: When Scheduled trigger selected
  SelectedUserType: string = "";               // Level 6: Based on configuration permissions
  SelectedWhatsAppEnabled: boolean = false;    // Level 7: Toggle switch
  SelectedEmailOptions = {                     // Level 8: Email toggles
    toEmail: false,
    ccEmail: false,
    bccEmail: false
  };

  // Selected configuration for saving
  SelectedConfigurationId: number = 0;
  SelectedConfiguration: any = null;

  // =====================================================
  // CACHED DROPDOWN DATA - Performance Optimization
  // =====================================================

  // Cached dropdown options to prevent method calls in templates
  cachedCategoryTypes: { value: string, label: string }[] = [];
  cachedNotificationTypes: { value: string, label: string, config: any }[] = [];
  cachedReportTypes: { value: string, label: string, config: any }[] = [];
  cachedAllowedTriggerTypes: { value: string, label: string, description: string }[] = [];
  cachedAllowedUserTypes: { value: string, label: string }[] = [];

  // Cached trigger descriptions for display
  cachedTriggerDescriptions: string[] = [];

  // =====================================================
  // SMART LOOP PREVENTION SYSTEM
  // =====================================================

  // Track initialization state to allow first-time execution
  private isComponentInitialized: boolean = false;

  // Track programmatic updates to prevent circular calls
  private isProgrammaticUpdate: boolean = false;

  // Track last user interaction timestamp to distinguish user vs programmatic changes
  private lastUserInteractionTime: number = 0;

  // Debounce threshold for user interactions (ms)
  private readonly USER_INTERACTION_DEBOUNCE = 100;

  // =====================================================
  // SMART LOOP PREVENTION METHODS
  // =====================================================

  /**
   * Determines if a change handler should execute based on context
   * @param currentValue - Current stored value
   * @param newValue - New incoming value
   * @param context - Context of the change (user, programmatic, initialization)
   * @returns true if handler should execute, false if should skip
   */
  private shouldExecuteChangeHandler(currentValue: any, newValue: any, context: 'user' | 'programmatic' | 'initialization' | 'force' = 'user'): boolean {
    // Always execute on force or initialization
    if (context === 'force' || context === 'initialization') {
      return true;
    }

    // Skip programmatic updates if values are the same (prevents loops)
    if (context === 'programmatic' && this.valuesAreEqual(currentValue, newValue)) {
      return false;
    }

    // For user interactions, check if this is a legitimate change
    if (context === 'user') {
      // Allow execution if component is not yet initialized (first load)
      if (!this.isComponentInitialized) {
        return true;
      }

      // Allow execution if values are actually different
      if (!this.valuesAreEqual(currentValue, newValue)) {
        return true;
      }

      // For same values, check if this is a recent user interaction
      const now = Date.now();
      const timeSinceLastInteraction = now - this.lastUserInteractionTime;

      // If it's been a while since last interaction, this might be a legitimate re-selection
      if (timeSinceLastInteraction > this.USER_INTERACTION_DEBOUNCE) {
        this.lastUserInteractionTime = now;
        return true;
      }

      // Otherwise, skip to prevent rapid-fire duplicate calls
      return false;
    }

    return true;
  }

  /**
   * Compares two values for equality, handling arrays and objects
   */
  private valuesAreEqual(value1: any, value2: any): boolean {
    if (Array.isArray(value1) && Array.isArray(value2)) {
      return JSON.stringify(value1.sort()) === JSON.stringify(value2.sort());
    }
    return value1 === value2;
  }

  /**
   * Marks the beginning of a programmatic update to prevent loops
   */
  private startProgrammaticUpdate(): void {
    this.isProgrammaticUpdate = true;
  }

  /**
   * Marks the end of a programmatic update
   */
  private endProgrammaticUpdate(): void {
    setTimeout(() => {
      this.isProgrammaticUpdate = false;
    }, 0);
  }

  /**
   * Records a user interaction timestamp
   */
  private recordUserInteraction(): void {
    this.lastUserInteractionTime = Date.now();
  }

  TriggerTypeList: any[] = [
    { id: 1, name: "Event", value: "Event", description: "Triggered automatically by system events" },
    { id: 2, name: "Scheduled", value: "Scheduled", description: "Triggered on a regular schedule" },
    { id: 3, name: "On-Demand", value: "OnDemand", description: "Triggered manually by users" },
  ];

  UserTypeList: any[] = [
    { value: 'Internal', label: 'Internal Users' },
    { value: 'External', label: 'External Users' },
    { value: 'Customer', label: 'Customer Users' }
  ];

  SelectedTriggerType: string[] = [];
  SelectNotificationType: any;
  showScheduleOptions: boolean = false;
  showOnDemandOptions: boolean = false;

  selectedOrderStage: "";
  isOnlyInternal: false;
  isOnlyCustomer: false;

  showInternalUser = false;
  showCustomerList = false;
  isUserTypeExternal = false;

  UserList: UserModel[] = [];
  CustomerList: CustomerModel[] = [];
  cronScheduleDescription: string = '';

  ngOnInit(): void {
    this.logger.debug('NotificationGroupComponent initializing');

    this.permission.View = this.auth.CheckResponsibility(
      Modules.NotificationGroup,
      Responsibility.View
    );
    this.permission.Add = this.auth.CheckResponsibility(
      Modules.NotificationGroup,
      Responsibility.Add
    );
    this.permission.Edit = this.auth.CheckResponsibility(
      Modules.NotificationGroup,
      Responsibility.Edit
    );
    this.permission.Delete = this.auth.CheckResponsibility(
      Modules.NotificationGroup,
      Responsibility.Delete
    );

    this.logger.debug('NotificationGroup permissions checked', {
      hasViewPermission: this.permission.View,
      hasAddPermission: this.permission.Add,
      hasEditPermission: this.permission.Edit,
      hasDeletePermission: this.permission.Delete
    });

    if (this.permission.View != true) {
      this.logger.warn('User lacks notification group view permission, redirecting to unauthorized');
      this.router.navigate(["/home/unauthorized"]);
      return;
    }

    // Initialize the form and data
    this.createForm();
    this.setupFormSubscriptions();
    this.GetAllNotificationTypes();
    this.GetAllNotificationsGroup();
    this.GetAllUsers();
    this.GetAllCustomer();
    this.GetAllWhatsAppTemplateList();

    this.logger.debug('NotificationGroupComponent initialization completed');
  }
  // Mobile number validator using the new validation service
  private mobileNumberValidator(): ValidatorFn {
    return this.mobileValidationService.createInternationalMobileValidator();
  }

  createForm() {
    this.validateForm = this.fb.group({
      // Level 1: Category Type (filter only, not saved)
      CategoryType: [""],

      // Level 2: Notification Type (cascading from Category)
      NotificationType: ["", [Validators.required]],

      // Level 3: Report Type (SubType for Reports only)
      ReportType: [""],

      // Level 4: Trigger Type (filtered by configuration capabilities)
      TriggerType: [[], [Validators.required]],

      // Level 5: CRON Schedule (when Scheduled trigger selected)
      CronScheduleExpression: ["", [this.cronExpressionValidator()]],
      ScheduleTime: [""],

      // Level 6: User Type (filtered by configuration permissions)
      UserType: ["", [Validators.required]],

      // Level 7: WhatsApp Notification
      IsWhatsAppNotificationEnabled: [false],

      // Push Notification
      IsPushNotificationEnabled: [false],

      // Level 8: Email Options
      EnableToEmail: [false],
      EnableCcemail: [false],
      EnableBccemail: [false],

      // User details
      Name: [""],
      Email: [
        "",
        [
          Validators.pattern(
            "^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}(,[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4})*$"
          ),
        ],
      ],
      UserMasterId: [""],
      MobileNumber: ["", [this.mobileNumberValidator()]],

      // Configuration ID for template mapping
      ConfigurationId: [0, [Validators.required]]
    });
  }

  // Helper method to get user-friendly category type names
  getCategoryTypeDisplayName(categoryType: string): string {
    const displayNames = {
      'Inventory': 'Inventory Management',
      'Production': 'Production Management',
      'Costing': 'Cost Management',
      'Procurement': 'Procurement Management'
    };
    return displayNames[categoryType] || categoryType;
  }

  private setupFormSubscriptions() {
    const cronControl = this.validateForm.get('CronScheduleExpression');
    if (cronControl) {
      cronControl.valueChanges
        .pipe(
          debounceTime(300)
        )
        .subscribe({
          next: (value) => {
            this.updateCronDescription(value);
          },
          error: (error) => {
            this.logger.error('Error in cron expression subscription', error, 'NotificationGroupComponent');
          }
        });
    }
  }
  private cronExpressionValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const cronExpression = control.value;

      if (!cronExpression) {
        return null;
      }

      try {
        // Attempt to parse the cron expression
        cronstrue.toString(cronExpression);
        return null;
      } catch (error) {
        return { invalidCron: true };
      }
    };
  }
  private updateCronDescription(cronExpression: string) {
    try {
      if (cronExpression && this.validateForm.get('CronScheduleExpression').valid) {
        this.cronScheduleDescription = cronstrue.toString(cronExpression);
      } else {
        this.cronScheduleDescription = '';
      }
    } catch (error) {
      this.cronScheduleDescription = '';
    }
    this.logger.debug('Cron schedule description updated', {
      expression: cronExpression,
      description: this.cronScheduleDescription
    });
  }

  GetAllUsers(): Observable<UserModel[]> {
    const startTime = Date.now();
    this.loader.show();
    let url = this.ApiUrl + "userrolesresponsibility/getalluserdata";

    this.logger.api('request', 'userrolesresponsibility/getalluserdata', { operation: 'GetAllUsers' });

    return this.http.get<UserModel[]>(url).pipe(
      tap({
        next: (res) => {
          const duration = Date.now() - startTime;
          this.logger.api('response', 'userrolesresponsibility/getalluserdata', {
            status: 200,
            duration,
            userCount: res.length
          });

          this.UserList = res;
          this.loader.hide();

          this.logger.info('Users loaded successfully', { userCount: res.length, duration });
        },
        error: (error) => {
          this.logger.api('error', 'userrolesresponsibility/getalluserdata', {
            status: error.status,
            message: error.message
          });

          this.loader.hide();
          this.logger.warn('Error loading users', error, 'NotificationGroupComponent');
        }
      })
    );
  }

  GetAllCustomer(): Observable<CustomerModel[]> {
    const startTime = Date.now();
    this.loader.show();
    let url = this.ApiUrl + "customer/getallcustomers";

    this.logger.api('request', 'customer/getallcustomers', { operation: 'GetAllCustomer' });

    return this.http.get<CustomerModel[]>(url).pipe(
      tap({
        next: (res) => {
          const duration = Date.now() - startTime;
          this.logger.api('response', 'customer/getallcustomers', {
            status: 200,
            duration,
            customerCount: res.length
          });

          this.CustomerList = res;
          this.loader.hide();

          this.logger.info('Customers loaded successfully', { customerCount: res.length, duration });
        },
        error: (error) => {
          this.logger.api('error', 'customer/getallcustomers', {
            status: error.status,
            message: error.message
          });

          this.loader.hide();
          this.logger.warn('Error loading customers', error, 'NotificationGroupComponent');
        }
      })
    );
  }

  GetAllNotificationTypes(): Observable<any[]> {
    const startTime = Date.now();
    let url = this.ApiUrl + "notificationconfig/getnotificationtypes";

    this.logger.api('request', 'notificationconfig/getnotificationtypes', { operation: 'GetAllNotificationTypes' });

    return this.http.get<any[]>(url).pipe(
      tap({
        next: (res) => {
          const duration = Date.now() - startTime;
          this.logger.api('response', 'notificationconfig/getnotificationtypes', {
            status: 200,
            duration,
            notificationTypeCount: res.length
          });

          // Store configuration data for hierarchical dropdowns
          this.NotificationConfigurationList = res;

          // Initialize cached dropdown data after loading configuration
          this.initializeCachedDropdownData();

          // Mark component as initialized after all data is loaded
          this.isComponentInitialized = true;

          this.logger.info('Notification types loaded successfully', {
            notificationTypeCount: res.length,
            duration,
            componentInitialized: this.isComponentInitialized
          });
        },
        error: (error) => {
          this.logger.api('error', 'notificationconfig/getnotificationtypes', {
            status: error.status,
            message: error.message
          });

          this.logger.error('Failed to load notification types from API', error, 'NotificationGroupComponent');
          this.alertService.error('Failed to load notification types. Please refresh the page or contact administrator.');

          // Initialize empty list instead of hardcoded fallback
          this.NotificationConfigurationList = [];
        }
      })
    );
  }



  // =====================================================
  // HIERARCHICAL DROPDOWN METHODS (8-Level Sequence)
  // =====================================================

  // Level 1: Category Type Change (Filter only, not saved)
  onCategoryTypeChange(categoryType: string) {
    // Smart loop prevention: determine context and whether to execute
    const context = this.isProgrammaticUpdate ? 'programmatic' : 'user';

    if (!this.shouldExecuteChangeHandler(this.SelectedCategoryType, categoryType, context)) {
      this.logger.debug('Category type change skipped - no actual change or preventing loop', {
        current: this.SelectedCategoryType,
        new: categoryType,
        context
      });
      return;
    }

    this.recordUserInteraction();
    this.logger.debug('Category type change executing', {
      from: this.SelectedCategoryType,
      to: categoryType,
      context,
      isInitialized: this.isComponentInitialized
    });

    this.SelectedCategoryType = categoryType;
    this.SelectedNotificationType = "";
    this.SelectedReportType = "";
    this.SelectedConfigurationId = 0;
    this.SelectedConfiguration = null;

    // Mark as programmatic update to prevent loops in dependent form controls
    this.startProgrammaticUpdate();

    // Reset form values with emitEvent: false to prevent circular updates
    this.validateForm.patchValue({
      NotificationType: "",
      ReportType: "",
      ConfigurationId: 0,
      TriggerType: [],
      UserType: ""
    }, { emitEvent: false });

    this.endProgrammaticUpdate();

    // Update cached dropdown data
    this.updateCachedNotificationTypes();
    this.updateCachedReportTypes();
    this.updateCachedAllowedTriggerTypes();
    this.updateCachedAllowedUserTypes();
    this.updateCachedTriggerDescriptions();

    this.logger.debug('Category type changed successfully', { categoryType });
  }

  // Level 2: Notification Type Change
  onNotificationTypeChange(notificationType: string) {
    // Smart loop prevention: determine context and whether to execute
    const context = this.isProgrammaticUpdate ? 'programmatic' : 'user';

    if (!this.shouldExecuteChangeHandler(this.SelectedNotificationType, notificationType, context)) {
      this.logger.debug('Notification type change skipped - no actual change or preventing loop', {
        current: this.SelectedNotificationType,
        new: notificationType,
        context
      });
      return;
    }

    this.recordUserInteraction();
    this.logger.debug('Notification type change executing', {
      from: this.SelectedNotificationType,
      to: notificationType,
      context
    });

    this.SelectedNotificationType = notificationType;
    this.SelectedReportType = "";
    this.SelectedConfigurationId = 0;
    this.SelectedConfiguration = null;

    // Mark as programmatic update to prevent loops in dependent form controls
    this.startProgrammaticUpdate();

    // Reset dependent form values with emitEvent: false to prevent circular updates
    this.validateForm.patchValue({
      ReportType: "",
      ConfigurationId: 0,
      TriggerType: [],
      UserType: ""
    }, { emitEvent: false });

    this.endProgrammaticUpdate();

    // For types with subtypes (Reports, PurchaseOrderApproval), wait for subtype selection
    if (notificationType !== 'Reports' && notificationType !== 'PurchaseOrderApproval') {
      this.updateSelectedConfiguration();
    }

    // Update cached dropdown data
    this.updateCachedReportTypes();
    this.updateCachedAllowedTriggerTypes();
    this.updateCachedAllowedUserTypes();
    this.updateCachedTriggerDescriptions();

    this.logger.debug('Notification type changed successfully', { notificationType });
  }

  // Level 3: Report Type Change (SubType for Reports)
  onReportTypeChange(reportType: string) {
    // Smart loop prevention: determine context and whether to execute
    const context = this.isProgrammaticUpdate ? 'programmatic' : 'user';

    if (!this.shouldExecuteChangeHandler(this.SelectedReportType, reportType, context)) {
      this.logger.debug('Report type change skipped - no actual change or preventing loop', {
        current: this.SelectedReportType,
        new: reportType,
        context
      });
      return;
    }

    this.recordUserInteraction();
    this.logger.debug('Report type change executing', {
      from: this.SelectedReportType,
      to: reportType,
      context
    });

    this.SelectedReportType = reportType;

    // Find the configuration based on selections
    this.updateSelectedConfiguration();

    // Update cached dropdown data
    this.updateCachedAllowedTriggerTypes();
    this.updateCachedAllowedUserTypes();
    this.updateCachedTriggerDescriptions();

    this.logger.debug('Report type changed successfully', { reportType });
  }

  // Level 4: Trigger Type Change
  onTriggerTypeChange(triggerTypes: string[]) {
    // Smart loop prevention: determine context and whether to execute
    const context = this.isProgrammaticUpdate ? 'programmatic' : 'user';

    if (!this.shouldExecuteChangeHandler(this.SelectedTriggerTypes, triggerTypes, context)) {
      this.logger.debug('Trigger type change skipped - no actual change or preventing loop', {
        current: this.SelectedTriggerTypes,
        new: triggerTypes,
        context
      });
      return;
    }

    this.recordUserInteraction();
    this.logger.debug('Trigger type change executing', {
      from: this.SelectedTriggerTypes,
      to: triggerTypes,
      context
    });

    this.SelectedTriggerTypes = triggerTypes || [];

    // Show/hide CRON expression based on Scheduled trigger
    this.showScheduleOptions = this.SelectedTriggerTypes.includes('Scheduled');

    // 🔧 REMOVED: this.validateForm.patchValue() to prevent circular updates
    // The form control is already updated by Angular's two-way binding

    // Update cached trigger descriptions
    this.updateCachedTriggerDescriptions();

    this.logger.debug('Trigger types changed successfully', {
      triggerTypes: this.SelectedTriggerTypes,
      showSchedule: this.showScheduleOptions
    });
  }

  // Level 6: User Type Change
  // Level 6: User Type Change
  onUserTypeChange(userType: string, resetValues: boolean = true): Observable<any> | void {
    // Prevent infinite loops by checking if value actually changed
    // if (this.SelectedUserType === userType) {
    //   return;
    // }

    this.SelectedUserType = userType;
    let loading$ = null;

    // Handle user type specific logic
    if (userType == "Internal") {
      this.showInternalUser = true;
      this.showCustomerList = false;
      this.isUserTypeExternal = false;
      this.AddNotificationGroups.UserMasterId = null;

      // Use emitEvent: false to prevent circular updates
      if (resetValues) {
        this.validateForm.patchValue({ UserMasterId: null }, { emitEvent: false });
      }
      loading$ = this.GetAllUsers();
    } else if (userType == "Customer") {
      this.showInternalUser = false;
      this.showCustomerList = true;
      this.isUserTypeExternal = false;

      // Use emitEvent: false to prevent circular updates
      if (resetValues) {
        this.validateForm.patchValue({ UserMasterId: null }, { emitEvent: false });
      }
      loading$ = this.GetAllCustomer();
    } else if (userType == "External") {
      this.isUserTypeExternal = true;
      this.showInternalUser = false;
      this.showCustomerList = false;
    }

    this.logger.debug('User type changed', { userType });

    // If there is an observable, subscribe to it to ensure data loads even if caller doesn't subscribe
    // But return it so caller CAN wait if they want
    if (loading$) {
      // We share the observable so we don't trigger two http requests if validation waits
      // validation logic needs to handle subscription if they want to wait
      // Note: To simple keep current behavior for regular UI interactions, we should subscribe here IF not controlled by caller?
      // Actually, HttpClient observables are cold. If we return it, and caller doesn't subscribe, it won't fire.
      // So we MUST subscribe here.
      // But if we subscribe here and return it, and caller subscribes, we get 2 requests.
      // Unless we use shareReplay or similar.
      // Simpler approach: Check if we are in 'programmatic update' or just return it and let caller decide?
      // For UI dropdown change, nobody catches return value. So we must subscribe.
      // For Edit setup, we want to wait.

      // Ideally:
      const shared$ = loading$.pipe(shareReplay(1));
      shared$.subscribe(); // Ensure it runs for UI interaction
      return shared$;
    }
  }

  // Helper method to update selected configuration
  private updateSelectedConfiguration() {
    if (!this.SelectedCategoryType || !this.SelectedNotificationType) {
      return;
    }

    // Find matching configuration
    let config = this.NotificationConfigurationList.find(c =>
      c.CategoryType === this.SelectedCategoryType &&
      c.NotificationType === this.SelectedNotificationType &&
      (this.SelectedReportType ? c.SubType === this.SelectedReportType : !c.SubType)
    );

    if (config) {
      // Prevent infinite loops by checking if configuration actually changed
      if (this.SelectedConfigurationId === config.ConfigurationId) {
        return;
      }

      this.SelectedConfigurationId = config.ConfigurationId;
      this.SelectedConfiguration = config;

      // Use emitEvent: false to prevent circular updates
      this.validateForm.patchValue({
        ConfigurationId: config.ConfigurationId
      }, { emitEvent: false });

      this.logger.debug('Configuration selected', {
        configurationId: config.ConfigurationId,
        displayName: config.DisplayName
      });
    }
  }

  // =====================================================
  // CACHED DROPDOWN UPDATE METHODS - Performance Optimization
  // =====================================================

  // Initialize all cached dropdown data
  initializeCachedDropdownData() {
    this.updateCachedCategoryTypes();
    this.updateCachedNotificationTypes();
    this.updateCachedReportTypes();
    this.updateCachedAllowedTriggerTypes();
    this.updateCachedAllowedUserTypes();
    this.updateCachedTriggerDescriptions();
  }

  // Update cached category types
  updateCachedCategoryTypes() {
    const categories = [...new Set(this.NotificationConfigurationList.map(c => c.CategoryType))];
    this.cachedCategoryTypes = categories.map(cat => ({
      value: cat,
      label: this.getCategoryTypeDisplayName(cat)
    }));
  }

  // Update cached notification types for selected category
  updateCachedNotificationTypes() {
    if (!this.SelectedCategoryType) {
      this.cachedNotificationTypes = [];
      return;
    }

    const configs = this.NotificationConfigurationList.filter(c =>
      c.CategoryType === this.SelectedCategoryType
    );

    // Group by NotificationType to avoid duplicates
    const uniqueTypes = configs.reduce((acc: any[], config) => {
      if (!acc.find((item: any) => item.value === config.NotificationType)) {
        acc.push({
          value: config.NotificationType,
          label: config.NotificationType === 'Reports' ? 'Reports & Analytics' : config.NotificationType === 'PurchaseOrderApproval' ? 'Purchase Order Approval' : config.DisplayName,
          config: config
        });
      }
      return acc;
    }, []);

    this.cachedNotificationTypes = uniqueTypes;
  }

  // Update cached report types for notification types that have subtypes (Reports, PurchaseOrderApproval)
  updateCachedReportTypes() {
    if (!this.SelectedCategoryType || (this.SelectedNotificationType !== 'Reports' && this.SelectedNotificationType !== 'PurchaseOrderApproval')) {
      this.cachedReportTypes = [];
      return;
    }

    this.cachedReportTypes = this.NotificationConfigurationList
      .filter(c =>
        c.CategoryType === this.SelectedCategoryType &&
        c.NotificationType === this.SelectedNotificationType &&
        c.SubType
      )
      .map(c => ({
        value: c.SubType,
        label: c.DisplayName,
        config: c
      }));
  }

  // Update cached allowed trigger types based on configuration
  updateCachedAllowedTriggerTypes() {
    if (!this.SelectedConfiguration) {
      this.cachedAllowedTriggerTypes = this.TriggerTypeList.map(trigger => ({
        value: trigger.value,
        label: trigger.name,
        description: trigger.description
      }));
      return;
    }

    this.cachedAllowedTriggerTypes = this.TriggerTypeList
      .filter(trigger => {
        switch (trigger.value) {
          case 'Event':
            return this.SelectedConfiguration.EventAllowed;
          case 'Scheduled':
            return this.SelectedConfiguration.SchedulingAllowed;
          case 'OnDemand':
            return this.SelectedConfiguration.OnDemandAllowed;
          default:
            return false;
        }
      })
      .map(trigger => ({
        value: trigger.value,
        label: trigger.name,
        description: trigger.description
      }));
  }

  // Update cached allowed user types based on configuration
  updateCachedAllowedUserTypes() {
    if (!this.SelectedConfiguration) {
      this.cachedAllowedUserTypes = [];
      return;
    }

    this.cachedAllowedUserTypes = this.UserTypeList.filter(userType => {
      switch (userType.value) {
        case 'Internal':
          return this.SelectedConfiguration.InternalAllowed;
        case 'External':
          return this.SelectedConfiguration.ExternalAllowed;
        case 'Customer':
          return this.SelectedConfiguration.CustomerAllowed;
        default:
          return false;
      }
    });
  }

  // Update cached trigger descriptions for display
  updateCachedTriggerDescriptions() {
    // Prevent infinite loops by ensuring SelectedTriggerTypes is valid
    if (!this.SelectedTriggerTypes || !Array.isArray(this.SelectedTriggerTypes)) {
      this.cachedTriggerDescriptions = [];
      return;
    }

    // Prevent infinite loops by ensuring cachedAllowedTriggerTypes is available
    if (!this.cachedAllowedTriggerTypes || this.cachedAllowedTriggerTypes.length === 0) {
      this.cachedTriggerDescriptions = [];
      return;
    }

    this.cachedTriggerDescriptions = this.SelectedTriggerTypes.map(selectedTrigger => {
      const trigger = this.cachedAllowedTriggerTypes.find(t => t.value === selectedTrigger);
      return trigger ? trigger.description : '';
    }).filter(desc => desc !== '');
  }

  // Check if sub-type dropdown should be shown (for Reports and PurchaseOrderApproval)
  shouldShowReportTypeDropdown(): boolean {
    return this.SelectedNotificationType === 'Reports' || this.SelectedNotificationType === 'PurchaseOrderApproval';
  }

  // Check if CRON schedule should be shown
  shouldShowCronSchedule(): boolean {
    return this.SelectedTriggerTypes.includes('Scheduled');
  }

  GetAllNotificationsGroup() {
    const startTime = Date.now();
    this.isTableLoading = true;
    this.loader.show();
    let url = this.ApiUrl + "notificationconfig/getallnotificationgroup";

    this.logger.api('request', 'notificationconfig/getallnotificationgroup', { operation: 'GetAllNotificationsGroup' });

    this.http.get<NotificationGroups[]>(url).subscribe({
      next: (res) => {
        const duration = Date.now() - startTime;
        this.logger.api('response', 'notificationconfig/getallnotificationgroup', {
          status: 200,
          duration,
          notificationGroupCount: res.length
        });

        res.forEach((item, index) => {
          item.SerialNumber = index + 1;
        });
        this.loader.hide();
        this.NotificationGroupList = res;
        this.NotificationGroupListOriginal = res;
        this.isTableLoading = false;
        this.NotificationGroupListExport = res;
        this.exportfields = [];

        this.NotificationGroupListExport.forEach((x) => {
          this.fields = new NotificationGroupsModelExport();

          this.fields.NotificationType = x.NotificationType;

          // Handle TriggerType - convert array to string for export if needed
          if (Array.isArray(x.TriggerType)) {
            this.fields.TriggerType = x.TriggerType.join(', ');
          } else {
            this.fields.TriggerType = x.TriggerType || 'Event'; // Default to Event if not set
          }

          this.fields.ReportName = x.ReportName || '';
          this.fields.Name = x.Name;
          this.fields.Email = x.Email;
          this.fields.UserType = x.UserType;
          this.fields.IsWhatsAppNotificationEnabled =
            x.IsWhatsAppNotificationEnabled;
          this.fields.MobileNumber = x.MobileNumber;
          this.fields.EnableToEmail = x.EnableToEmail;
          this.fields.EnableCcemail = x.EnableCcemail;
          this.fields.EnableBccemail = x.EnableBccemail;

          this.exportfields.push(this.fields);
        });

        this.logger.info('Notification groups loaded successfully', {
          groupCount: res.length,
          duration
        });
      },
      error: (error) => {
        this.logger.api('error', 'notificationconfig/getallnotificationgroup', {
          status: error.status,
          message: error.message,
          attempt: this.count + 1
        });

        this.loader.hide();
        this.count++;
        if (this.count < 2) {
          this.logger.warn('Retrying notification groups load', { attempt: this.count }, 'NotificationGroupComponent');
          this.GetAllNotificationsGroup();
        } else {
          this.logger.error('Failed to load notification groups after retries', { attempts: this.count }, 'NotificationGroupComponent');
          this.isTableLoading = false;
        }
      }
    });
  }



  onKeydown(event: any) {
    if (
      (event.target.selectionStart === 0 && event.code === "Space") ||
      (event.key === "Enter" && event.keyCode === 13)
    ) {
      event.preventDefault();
      event = this.search();
    }
  }
  ValidateText() {
    this.searchValue.trim();
    this.searchValue = this.searchValue.trim();
  }

  search() {
    var res = this.NotificationGroupListOriginal;
    this.NotificationGroupList = res.filter((item: NotificationGroups) => {
      if (
        item?.NotificationType?.toLowerCase().includes(
          this.searchValue?.toLowerCase()
        )
      ) {
        return true;
      } else if (
        item?.UserType?.toLowerCase().includes(this.searchValue?.toLowerCase())
      ) {
        return true;
      } else if (
        item?.Name?.toLowerCase().includes(this.searchValue?.toLowerCase())
      ) {
        return true;
      } else if (
        item?.Email?.toLowerCase().includes(this.searchValue?.toLowerCase())
      ) {
        return true;
      } else if (
        item?.MobileNumber?.toLowerCase().includes(
          this.searchValue?.toLowerCase()
        )
      ) {
        return true;
      }
      return false;
    });
  }

  reset(): void {
    this.searchValue = "";
    this.search();
  }

  export() {
    var exportdate = format(new Date(), "-ddMMyyyy-hhmmss");
    if (this.exportfields.length > 0)
      new AngularCsv(
        this.exportfields,
        "notification-export" + exportdate,
        this.exportoptions
      );
  }

  handleDelete(data: NotificationGroups) {
    const modal = this.modalService.confirm({
      nzTitle: "Confirm",
      nzContent: "Are you sure to delete this Group?",
      nzOkDanger: true,
      nzOkText: "Yes",
      nzOnOk: () => this.DeleteNotificationGroup(data),
    });
    setTimeout(() => modal.destroy(), 5000);
  }

  DeleteNotificationGroup(data: NotificationGroups) {
    let url = this.ApiUrl + "notificationconfig/notificationgroupupdate";
    data.Disabled = true;

    this.logger.api('request', 'notificationconfig/notificationgroupupdate', {
      operation: 'deleteNotificationGroup',
      groupId: data.NotificationGroupUserId
    });

    this.http.post<any>(url, data).subscribe({
      next: (_) => {
        this.logger.api('response', 'notificationconfig/notificationgroupupdate', {
          status: 200,
          operation: 'delete'
        });

        this.alertService.success("Deleted Successfully");
        this.isLoading = false;
        this.GetAllNotificationsGroup();

        this.logger.info('Notification group deleted successfully', {
          groupId: data.NotificationGroupUserId
        });
      },
      error: (res) => {
        this.logger.api('error', 'notificationconfig/notificationgroupupdate', {
          status: res.status,
          statusCode: res.StatusCode,
          message: res.error?.ResponseBody,
          operation: 'delete'
        });

        if (res.StatusCode == 400) {
          this.alertService.warning(res.error.ResponseBody);
        } else {
          this.alertService.error(res.error.ResponseBody);
          this.isLoading = false;
        }
      },
    });
  }

  handleOk(): void {
    this.isLoading = true;
    this.SaveNotificationGroup();
  }

  setWhatsAppNotification(isEnabled: boolean) {
    // Prevent infinite loops by checking if value actually changed
    if (this.AddNotificationGroups.IsWhatsAppNotificationEnabled === isEnabled) {
      return;
    }

    this.logger.debug('WhatsApp notification toggle changed', { isEnabled });

    this.AddNotificationGroups.IsWhatsAppNotificationEnabled = isEnabled;

    // 🔧 REMOVED: this.validateForm.patchValue() to prevent circular updates
    // The form control is already updated by Angular's two-way binding

    // Only validate mobile numbers when enabling WhatsApp notifications
    if (isEnabled) {
      // Use setTimeout to prevent validation loops and allow form to stabilize
      setTimeout(() => {
        this.validateMobileNumberForWhatsApp();
      }, 0);
    }
  }

  setPushNotification(isEnabled: boolean) {
    if (this.AddNotificationGroups.IsPushNotificationEnabled === isEnabled) {
      return;
    }
    this.AddNotificationGroups.IsPushNotificationEnabled = isEnabled;
  }

  // 🔧 NEW: Separate method for mobile number validation to prevent loops
  private validateMobileNumberForWhatsApp() {
    const userType = this.validateForm.get("UserType")?.value;

    if (userType === 'Internal') {
      const userMasterId = this.validateForm.get("UserMasterId")?.value;
      const userMobileCheck = this.UserList.find(x => x.UserId == userMasterId);

      if (!userMobileCheck || !userMobileCheck.Contact) {
        this.alertService.warning("No Mobile Number is saved in Users Master for this user. Messages will not be sent unless it is updated");
      } else {
        const validationResult = this.mobileValidationService.validateInternationalNumber(userMobileCheck.Contact);
        if (!validationResult.isValid) {
          this.alertService.warning(`The mobile number in Users Master is invalid: ${validationResult.error}. Messages may not be delivered correctly.`);
        }
      }
    } else if (userType === 'Customer') {
      const userMasterId = this.validateForm.get("UserMasterId")?.value;
      const customerMobileCheck = this.CustomerList.find(x => x.CustomerId == userMasterId);

      if (!customerMobileCheck || !customerMobileCheck.CustomerContactNumber) {
        this.alertService.warning("No Mobile Number present in Customer Master for selected customer. Messages will not be sent unless it is updated");
      } else {
        const validationResult = this.mobileValidationService.validateInternationalNumber(customerMobileCheck.CustomerContactNumber);
        if (!validationResult.isValid) {
          this.alertService.warning(`The mobile number in Customer Master is invalid: ${validationResult.error}. Messages may not be delivered correctly.`);
        }
      }
    }
    // For External users, the mobile number is validated by the form validator automatically
  }

  setEnableToEmail(isEnabled: boolean) {
    // Prevent infinite loops by checking if value actually changed
    if (this.AddNotificationGroups.EnableToEmail === isEnabled) {
      return;
    }

    this.AddNotificationGroups.EnableToEmail = isEnabled;

    if (isEnabled) {
      // Reset other email options when enabling To Email
      this.AddNotificationGroups.EnableCcemail = false;
      this.AddNotificationGroups.EnableBccemail = false;

      // 🔧 Use setTimeout to prevent circular updates
      setTimeout(() => {
        this.validateForm.patchValue({
          EnableCcemail: false,
          EnableBccemail: false,
        }, { emitEvent: false }); // emitEvent: false prevents triggering change events
      }, 0);
    }
  }

  setEnableCcemail(isEnabled: boolean) {
    // Prevent infinite loops by checking if value actually changed
    if (this.AddNotificationGroups.EnableCcemail === isEnabled) {
      return;
    }

    this.AddNotificationGroups.EnableCcemail = isEnabled;

    if (isEnabled) {
      // Reset other email options when enabling CC Email
      this.AddNotificationGroups.EnableToEmail = false;
      this.AddNotificationGroups.EnableBccemail = false;

      // 🔧 Use setTimeout to prevent circular updates
      setTimeout(() => {
        this.validateForm.patchValue({
          EnableToEmail: false,
          EnableBccemail: false,
        }, { emitEvent: false }); // emitEvent: false prevents triggering change events
      }, 0);
    }
  }

  setEnableBccemail(isEnabled: boolean) {
    // Prevent infinite loops by checking if value actually changed
    if (this.AddNotificationGroups.EnableBccemail === isEnabled) {
      return;
    }

    this.AddNotificationGroups.EnableBccemail = isEnabled;

    if (isEnabled) {
      // Reset other email options when enabling BCC Email
      this.AddNotificationGroups.EnableToEmail = false;
      this.AddNotificationGroups.EnableCcemail = false;

      // 🔧 Use setTimeout to prevent circular updates
      setTimeout(() => {
        this.validateForm.patchValue({
          EnableToEmail: false,
          EnableCcemail: false,
        }, { emitEvent: false }); // emitEvent: false prevents triggering change events
      }, 0);
    }
  }
  SetReminderScheduleAllowed(event: any) {
    if (!event)
      return;

    this.AddNotificationGroups.NotificationType = event.value;
    this.SelectNotificationType = event;

    // Update report name visibility based on notification type and trigger types


    if (event.IsReminderScheduleAllowed) {
      this.AddNotificationGroups.IsReminderScheduleAllowed = true;
    }
    else {
      this.AddNotificationGroups.IsReminderScheduleAllowed = false;
    }
  }









  // Helper method to check if a value is an array
  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  getTriggerTypeColor(triggerType: string): string {
    switch (triggerType) {
      case 'Event':
        return 'blue';
      case 'Scheduled':
        return 'green';
      case 'OnDemand':
        return 'orange';
      default:
        return 'blue'; // Default to Event
    }
  }

  SaveNotificationGroup() {
    // 🔧 FIX: Disable hidden controls to prevent validation errors from blocking save
    const userType = this.validateForm.get("UserType").value;
    if (userType !== 'External') {
      this.validateForm.get('Name')?.disable({ emitEvent: false });
      this.validateForm.get('Email')?.disable({ emitEvent: false });
      this.validateForm.get('MobileNumber')?.disable({ emitEvent: false });
      this.validateForm.get('UserMasterId')?.enable({ emitEvent: false });
    } else {
      this.validateForm.get('Name')?.enable({ emitEvent: false });
      this.validateForm.get('Email')?.enable({ emitEvent: false });
      this.validateForm.get('MobileNumber')?.enable({ emitEvent: false });
      this.validateForm.get('UserMasterId')?.disable({ emitEvent: false });
    }

    const triggerType = this.validateForm.get("TriggerType").value || [];
    const isScheduled = Array.isArray(triggerType) ? triggerType.includes('Scheduled') : triggerType === 'Scheduled';

    if (!isScheduled) {
      this.validateForm.get('CronScheduleExpression')?.disable({ emitEvent: false });
      this.validateForm.get('ScheduleTime')?.disable({ emitEvent: false });
    } else {
      this.validateForm.get('CronScheduleExpression')?.enable({ emitEvent: false });
      this.validateForm.get('ScheduleTime')?.enable({ emitEvent: false });
    }

    if (this.validateForm.invalid) {
      Object.values(this.validateForm.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
      this.isLoading = false
      return;
    }

    // CRITICAL: Preserve the NotificationGroupUserId for updates
    const originalNotificationGroupUserId = this.AddNotificationGroups.NotificationGroupUserId;

    // Set trigger type - ensure it's an array
    const triggerTypeValue = this.validateForm.get("TriggerType").value;
    this.AddNotificationGroups.TriggerType = Array.isArray(triggerTypeValue) ? triggerTypeValue : [triggerTypeValue];

    // Handle schedule-specific fields
    if (this.AddNotificationGroups.TriggerType.includes('Scheduled')) {
      this.AddNotificationGroups.CronScheduleExpression = this.validateForm.get("CronScheduleExpression").value;
      // this.AddNotificationGroups.ScheduleFrequency = this.validateForm.get("ScheduleFrequency").value;
      this.AddNotificationGroups.ScheduleTime = this.validateForm.get("ScheduleTime").value;
    } else {
      this.AddNotificationGroups.CronScheduleExpression = '';
      // this.AddNotificationGroups.ScheduleFrequency = '';
      this.AddNotificationGroups.ScheduleTime = '';
    }

    // Set report name if applicable (from ReportType field in new hierarchy)
    if (this.shouldShowReportTypeDropdown()) {
      this.AddNotificationGroups.ReportName = this.validateForm.get("ReportType").value || '';
    } else {
      this.AddNotificationGroups.ReportName = '';
    }

    // Set configuration ID for automatic template mapping
    this.AddNotificationGroups.ConfigurationId = this.validateForm.get("ConfigurationId").value;

    this.AddNotificationGroups.NotificationType = this.validateForm.get("NotificationType").value;
    this.AddNotificationGroups.UserType = this.validateForm.get("UserType").value;

    // CRITICAL: Ensure NotificationGroupUserId is preserved for updates
    if (this.isShownEdit && originalNotificationGroupUserId) {
      this.AddNotificationGroups.NotificationGroupUserId = originalNotificationGroupUserId;
    }

    if (this.AddNotificationGroups.UserType == "External") {
      this.AddNotificationGroups.Name = this.validateForm.get("Name").value;
      this.AddNotificationGroups.Email = this.validateForm.get("Email").value;
      this.AddNotificationGroups.MobileNumber = this.validateForm.get("MobileNumber").value;
    } else {
      this.AddNotificationGroups.Name = "";
      this.AddNotificationGroups.Email = "";
      this.AddNotificationGroups.MobileNumber = ""
    }

    if (this.AddNotificationGroups.UserType == "Customer" || this.AddNotificationGroups.UserType == "Internal") {
      this.AddNotificationGroups.UserMasterId = this.validateForm.get("UserMasterId").value;
    } else {
      this.AddNotificationGroups.UserMasterId = null
    }

    // if (this.AddNotificationGroups.IsWhatsAppNotificationEnabled) {
    //   this.AddNotificationGroups.WhatsAppTemplateMasterId = this.validateForm.get("WhatsAppTemplateMasterId").value;
    // }

    if (!this.Validate(this.AddNotificationGroups)) {
      this.isLoading = false;
      return;
    }

    if (this.isShownEdit) {
      // Debug logging to verify the data being sent for update
      console.log('UPDATE MODE - Sending data:', {
        NotificationGroupUserId: this.AddNotificationGroups.NotificationGroupUserId,
        TriggerType: this.AddNotificationGroups.TriggerType,
        NotificationType: this.AddNotificationGroups.NotificationType,
        isShownEdit: this.isShownEdit
      });

      // Validate that we have a valid NotificationGroupUserId for updates
      if (!this.AddNotificationGroups.NotificationGroupUserId) {
        this.alertService.error("Error: Missing NotificationGroupUserId for update operation");
        this.isLoading = false;
        return;
      }

      let url = this.ApiUrl + "notificationconfig/notificationgroupupdate";
      this.http
        .post<NotificationGroups>(url, this.AddNotificationGroups)
        .subscribe({
          next: (_) => {
            this.alertService.success(
              "Notification Group Updated Successfully"
            );
            this.isLoading = this.isVisible = false;
            this.GetAllNotificationsGroup();
          },
          error: (error) => {
            console.error('Update error:', error);
            this.alertService.error(
              error.error || "An error has been occured. Please try again"
            );
            this.isLoading = this.isVisible = false;
          },
        });
    } else {
      let url = this.ApiUrl + "notificationconfig/addnotificationgroup";
      this.http
        .post<AddNotificationGroups>(url, this.AddNotificationGroups)
        .subscribe({
          next: (_) => {
            this.alertService.success("Notification Group Added Successfully");
            this.isLoading = this.isVisible = false;
            this.GetAllNotificationsGroup();
          },
          error: (_) => {
            this.alertService.error(
              "An error has been occured. Please try again"
            );
            this.isLoading = this.isVisible = false;
          },
        });
    }
  }

  Validate(model: NotificationGroups) {
    var Isvalid: boolean = true;

    // Validate trigger type
    if (!model.TriggerType) {
      this.alertService.error("Select Trigger Type");
      Isvalid = false;
      return Isvalid;
    }

    // Validate schedule-specific fields
    if (model.TriggerType === 'Scheduled') {
      if (!model.CronScheduleExpression) {
        this.alertService.error("CRON Schedule Expression is required for scheduled notifications");
        Isvalid = false;
        return Isvalid;
      }

      if (!model.ScheduleFrequency) {
        this.alertService.error("Schedule Frequency is required for scheduled notifications");
        Isvalid = false;
        return Isvalid;
      }
    }

    // Validate notification type
    if (model.NotificationType == "0" || model.NotificationType == "") {
      this.alertService.error("Select Notification Type");
      Isvalid = false;
      return Isvalid;
    }

    // Validate user type and related fields
    if (model.UserType == "0" || model.UserType == "") {
      this.alertService.error("Select User Type");
      Isvalid = false;
    } else if (model.UserType == "Customer" && !model.UserMasterId) {
      this.alertService.error("Select Customer");
      Isvalid = false;
    } else if (model.UserType == "Internal" && !model.UserMasterId) {
      this.alertService.error("Select User");
      Isvalid = false;
    } else if (model.UserType == "External" && model.Name == "") {
      this.alertService.error("Enter Name");
      Isvalid = false;
    } else if (model.UserType == "External" && model.Email == "") {
      this.alertService.error("Enter Email");
      Isvalid = false;
    } else if (model.UserType == "External" && model.MobileNumber == "") {
      this.alertService.error("Enter Mobile Number");
      Isvalid = false;
    } else if (model.UserType == "External" && model.MobileNumber) {
      const validationResult = this.mobileValidationService.validateInternationalNumber(model.MobileNumber.toString());
      if (!validationResult.isValid) {
        this.alertService.error(`Invalid mobile number: ${validationResult.error}`);
        Isvalid = false;
      }
    }

    // Legacy validation for backward compatibility
    if (model.CronScheduleExpression == "" && model.IsReminderScheduleRequired) {
      this.alertService.error("Schedule is required for selected notification type");
      Isvalid = false;
    }

    // else if(model.Name == '') {
    //   this.alertService.error("Enter Name"); Isvalid = false;
    // }
    // else if(model.Email== '') {
    //   this.alertService.error("Enter Email"); Isvalid = false;
    // }
    // else if(model.MobileNumber == '') {
    //   this.alertService.error("Enter Mobile Number"); Isvalid = false;
    // }

    return Isvalid;
  }

  showModal(): void {
    this.PopUpTitle = "Add Notification Group";
    this.NotificationTitle = "Add New Notification Group";
    this.isVisible = true;
    this.isShownEdit = false;
    this.validateForm.reset();
    this.AddNotificationGroups = new NotificationGroups();
    this.isUserTypeExternal = false;
    this.showInternalUser = false;
    this.showCustomerList = false;
    this.showScheduleOptions = false;
    this.showOnDemandOptions = false;
    this.SelectedTriggerType = [];
    this.SelectNotificationType = null;

    // Reset notification type list to full list from API
    // Reset notification type list to full list from API
    this.GetAllNotificationTypes().subscribe();

    this.GetAllWhatsAppTemplateList();
  }

  // ===================================================================
  // EDIT FLOW - Refactored Implementation
  // ===================================================================

  /**
   * Main entry point for editing a notification group.
   * Uses async/await for proper sequencing of data loading.
   */
  async editNotificationGroup(value: any): Promise<void> {
    if (!value?.NotificationGroupUserId) {
      return;
    }

    this.logger.debug('EDIT MODE - Starting edit flow', {
      notificationGroupUserId: value.NotificationGroupUserId
    });

    // Step 1: Reset UI state
    this.resetEditState();

    // Step 2: Set modal titles and visibility
    this.PopUpTitle = "Edit Notification Group";
    this.NotificationTitle = "Edit Notification Group";
    this.isVisible = true;
    this.isShownEdit = true;

    try {
      this.loader.show();

      // Step 3: Ensure configuration data is loaded
      await this.ensureConfigurationLoaded();

      // Step 4: Initialize the model from the input value
      this.initializeEditModel(value);

      // Step 5: Find and apply matching configuration
      const config = this.findMatchingConfiguration(value);
      if (config) {
        this.applyConfigurationForEdit(config);
      } else {
        this.alertService.warning(
          `Configuration for "${value.NotificationType}" not found. Please select a valid notification type.`
        );
      }

      // Step 6: Load dependent data based on user type
      await this.loadDependentDataForEdit(value.UserType);

      // Step 7: Populate the form from the model
      this.populateFormFromModel();

      this.loader.hide();

      this.logger.debug('EDIT MODE - Edit flow completed successfully');
    } catch (error) {
      this.loader.hide();
      this.logger.error('EDIT MODE - Failed to setup edit form', error);
      this.alertService.error('Failed to load notification group for editing.');
      this.isVisible = false;
    }
  }

  /**
   * Resets all UI state flags to their default values for edit mode.
   */
  private resetEditState(): void {
    this.isUserTypeExternal = false;
    this.showInternalUser = false;
    this.showCustomerList = false;
    this.showScheduleOptions = false;
    this.showOnDemandOptions = false;
    this.cronScheduleDescription = '';

    // Reset hierarchical dropdown selections
    this.SelectedCategoryType = "";
    this.SelectedNotificationType = "";
    this.SelectedReportType = "";
    this.SelectedConfigurationId = 0;
    this.SelectedConfiguration = null;
    this.SelectedTriggerType = [];

    // Reset form
    this.validateForm.reset();
  }

  /**
   * Ensures configuration data is loaded from the API.
   * Returns a Promise that resolves when data is available.
   */
  private ensureConfigurationLoaded(): Promise<void> {
    if (this.NotificationConfigurationList.length > 0) {
      return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
      this.GetAllNotificationTypes().subscribe({
        next: () => resolve(),
        error: (err) => reject(err)
      });
    });
  }

  /**
   * Initializes the AddNotificationGroups model from the input value.
   * Handles TriggerType parsing and all field mappings.
   */
  private initializeEditModel(value: any): void {
    this.AddNotificationGroups = new NotificationGroups();

    // Critical: Preserve the NotificationGroupUserId for updates
    this.AddNotificationGroups.NotificationGroupUserId = value.NotificationGroupUserId;

    // Parse TriggerType - handle both string and array formats
    this.AddNotificationGroups.TriggerType = this.parseTriggerType(value.TriggerType);
    this.SelectedTriggerType = this.AddNotificationGroups.TriggerType as string[];

    // Copy basic fields
    this.AddNotificationGroups.NotificationType = value.NotificationType;
    this.AddNotificationGroups.ReportName = value.ReportName || '';
    this.AddNotificationGroups.UserType = value.UserType;
    this.AddNotificationGroups.UserMasterId = value.UserMasterId;
    this.AddNotificationGroups.Name = value.Name || '';
    this.AddNotificationGroups.Email = value.Email || '';
    this.AddNotificationGroups.MobileNumber = value.MobileNumber || '';

    // Schedule-related fields
    this.AddNotificationGroups.CronScheduleExpression = value.CronScheduleExpression || '';
    this.AddNotificationGroups.ScheduleTime = value.ScheduleTime || '';

    // Notification options
    this.AddNotificationGroups.IsWhatsAppNotificationEnabled = value.IsWhatsAppNotificationEnabled || false;
    this.AddNotificationGroups.IsPushNotificationEnabled = value.IsPushNotificationEnabled || false;
    this.AddNotificationGroups.EnableToEmail = value.EnableToEmail || false;
    this.AddNotificationGroups.EnableCcemail = value.EnableCcemail || false;
    this.AddNotificationGroups.EnableBccemail = value.EnableBccemail || false;

    // Configuration ID
    this.AddNotificationGroups.ConfigurationId = value.ConfigurationId || 0;

    this.logger.debug('EDIT MODE - Model initialized', {
      notificationGroupUserId: this.AddNotificationGroups.NotificationGroupUserId,
      triggerTypes: this.AddNotificationGroups.TriggerType
    });
  }

  /**
   * Parses TriggerType from various formats to a string array.
   */
  private parseTriggerType(triggerType: any): string[] {
    if (!triggerType) {
      return ['Event']; // Default
    }

    if (Array.isArray(triggerType)) {
      return triggerType;
    }

    if (typeof triggerType === 'string') {
      // Try parsing as JSON array
      if (triggerType.startsWith('[') && triggerType.endsWith(']')) {
        try {
          return JSON.parse(triggerType);
        } catch {
          return [triggerType];
        }
      }
      return [triggerType];
    }

    return ['Event'];
  }

  /**
   * Finds the matching configuration based on notification type and report name.
   */
  private findMatchingConfiguration(value: any): any {
    const notificationType = value.NotificationType;
    const reportName = value.ReportName;

    // First try matching by ConfigurationId if available
    if (value.ConfigurationId) {
      const configById = this.NotificationConfigurationList.find(c =>
        c.ConfigurationId === value.ConfigurationId
      );
      if (configById) return configById;
    }

    // For types with subtypes (Reports, PurchaseOrderApproval), match by SubType
    if ((notificationType === 'Reports' || notificationType === 'PurchaseOrderApproval') && reportName) {
      const configBySubType = this.NotificationConfigurationList.find(c =>
        c.NotificationType === notificationType && c.SubType === reportName
      );
      if (configBySubType) return configBySubType;
    }

    // Match by NotificationType
    const configByType = this.NotificationConfigurationList.find(c =>
      c.NotificationType === notificationType
    );
    if (configByType) return configByType;

    // Match by DisplayName (fallback)
    return this.NotificationConfigurationList.find(c =>
      c.DisplayName === notificationType
    );
  }

  /**
   * Applies the matched configuration to set up hierarchical dropdowns for edit mode.
   */
  private applyConfigurationForEdit(config: any): void {
    this.logger.debug('EDIT MODE - Applying configuration', {
      configurationId: config.ConfigurationId
    });

    // Set hierarchical selections
    this.SelectedCategoryType = config.CategoryType;
    this.SelectedNotificationType = config.NotificationType;
    this.SelectedReportType = config.SubType || '';
    this.SelectedConfigurationId = config.ConfigurationId;
    this.SelectedConfiguration = config;

    // Update model with configuration ID
    this.AddNotificationGroups.ConfigurationId = config.ConfigurationId;

    // Update all cached dropdown data
    this.updateCachedCategoryTypes();
    this.updateCachedNotificationTypes();
    this.updateCachedReportTypes();
    this.updateCachedAllowedTriggerTypes();
    this.updateCachedAllowedUserTypes();
    this.updateCachedTriggerDescriptions();

    // Set schedule options visibility based on trigger types
    this.showScheduleOptions = this.SelectedTriggerType.includes('Scheduled');
    this.showOnDemandOptions = this.SelectedTriggerType.includes('OnDemand');

    // Update CRON description if applicable
    if (this.showScheduleOptions && this.AddNotificationGroups.CronScheduleExpression) {
      this.updateCronDescription(this.AddNotificationGroups.CronScheduleExpression);
    }
  }

  /**
   * Loads dependent data based on user type for edit mode.
   * Returns a Promise that resolves when data is loaded.
   */
  private loadDependentDataForEdit(userType: string): Promise<void> {
    // Set UI flags based on user type
    if (userType === 'Internal') {
      this.showInternalUser = true;
      this.showCustomerList = false;
      this.isUserTypeExternal = false;
    } else if (userType === 'Customer') {
      this.showInternalUser = false;
      this.showCustomerList = true;
      this.isUserTypeExternal = false;
    } else if (userType === 'External') {
      this.showInternalUser = false;
      this.showCustomerList = false;
      this.isUserTypeExternal = true;
      return Promise.resolve(); // No data to load for external users
    }

    // Load users or customers
    return new Promise((resolve) => {
      if (userType === 'Internal') {
        const url = this.ApiUrl + "userrolesresponsibility/getalluserdata";
        this.http.get<UserModel[]>(url).subscribe({
          next: (res) => {
            this.UserList = res;
            resolve();
          },
          error: (err) => {
            this.logger.warn('Failed to load users for edit', err);
            resolve(); // Don't reject - allow form to continue
          }
        });
      } else if (userType === 'Customer') {
        const url = this.ApiUrl + "customer/getallcustomers";
        this.http.get<CustomerModel[]>(url).subscribe({
          next: (res) => {
            this.CustomerList = res;
            resolve();
          },
          error: (err) => {
            this.logger.warn('Failed to load customers for edit', err);
            resolve(); // Don't reject - allow form to continue
          }
        });
      } else {
        resolve();
      }
    });
  }

  /**
   * Populates the form with all values from the AddNotificationGroups model.
   * Single point of form population to avoid conflicts.
   */
  private populateFormFromModel(): void {
    this.validateForm.patchValue({
      // Hierarchical dropdowns
      CategoryType: this.SelectedCategoryType,
      NotificationType: this.SelectedNotificationType,
      ReportType: this.SelectedReportType,
      ConfigurationId: this.SelectedConfigurationId,

      // Trigger and schedule
      TriggerType: this.SelectedTriggerType,
      CronScheduleExpression: this.AddNotificationGroups.CronScheduleExpression,

      // User type and selection
      UserType: this.AddNotificationGroups.UserType,
      UserMasterId: this.AddNotificationGroups.UserMasterId,

      // External user fields
      Name: this.AddNotificationGroups.Name,
      Email: this.AddNotificationGroups.Email,
      MobileNumber: this.AddNotificationGroups.MobileNumber,

      // Notification options
      IsWhatsAppNotificationEnabled: this.AddNotificationGroups.IsWhatsAppNotificationEnabled,
      IsPushNotificationEnabled: this.AddNotificationGroups.IsPushNotificationEnabled,
      EnableToEmail: this.AddNotificationGroups.EnableToEmail,
      EnableCcemail: this.AddNotificationGroups.EnableCcemail,
      EnableBccemail: this.AddNotificationGroups.EnableBccemail
    }, { emitEvent: false });

    this.logger.debug('EDIT MODE - Form populated from model');
  }

  handleCancel(): void {
    this.isVisible = false;
    this.validateForm.reset();
  }

  // New methods for view drawer functionality
  viewNotificationGroup(data: NotificationGroups): void {
    this.selectedNotificationGroup = data;
    this.viewDrawerTitle = `Notification Group Details - ${data.NotificationType}`;
    this.isViewDrawerVisible = true;
    this.loadNotificationGroupDetails(Number(data.NotificationGroupUserId));
  }

  closeViewDrawer(): void {
    this.isViewDrawerVisible = false;
    this.selectedNotificationGroup = null;
    this.selectedNotificationGroupDetails = null;
    this.isLoadingDetails = false;
  }

  // Load detailed notification group information
  loadNotificationGroupDetails(notificationGroupUserId: number): void {
    this.isLoadingDetails = true;
    const url = `${this.ApiUrl}notificationconfig/getnotificationgroupdetails/${notificationGroupUserId}`;

    this.http.get<NotificationGroupDetails>(url).subscribe({
      next: (details) => {
        this.selectedNotificationGroupDetails = details;
        this.isLoadingDetails = false;
        console.log('Loaded notification group details:', details);
      },
      error: (error) => {
        console.error('Error loading notification group details:', error);
        this.alertService.error('Failed to load notification group details. Please try again.');
        this.isLoadingDetails = false;
      }
    });
  }

  // Method to handle action dropdown selections
  handleAction(action: string, data: NotificationGroups): void {
    switch (action) {
      case 'view':
        this.viewNotificationGroup(data);
        break;
      case 'edit':
        this.editNotificationGroup(data);
        break;
      case 'delete':
        this.handleDelete(data);
        break;
    }
  }

  // Helper method to format trigger types for display
  formatTriggerTypes(triggerType: string | string[]): string {
    if (Array.isArray(triggerType)) {
      return triggerType.join(', ');
    } else if (typeof triggerType === 'string') {
      try {
        // Try to parse as JSON array
        if (triggerType.startsWith('[') && triggerType.endsWith(']')) {
          const parsed = JSON.parse(triggerType);
          return Array.isArray(parsed) ? parsed.join(', ') : triggerType;
        }
        return triggerType;
      } catch {
        return triggerType;
      }
    }
    return 'Event'; // Default
  }

  // Helper method to get user display name
  getUserDisplayName(data: NotificationGroups): string {
    if (data.UserType === 'External') {
      return data.Name || 'N/A';
    } else if (data.UserType === 'Internal') {
      const user = this.UserList.find(u => u.UserId === data.UserMasterId);
      return user ? user.Name : 'N/A';
    } else if (data.UserType === 'Customer') {
      const customer = this.CustomerList.find(c => c.CustomerId === data.UserMasterId);
      return customer ? customer.CustomerName : 'N/A';
    }
    return 'N/A';
  }

  // Helper method to get contact information
  getContactInfo(data: NotificationGroups): string {
    if (data.UserType === 'External') {
      return data.Email || (data.MobileNumber ? data.MobileNumber.toString() : '') || 'N/A';
    } else if (data.UserType === 'Internal') {
      const user = this.UserList.find(u => u.UserId === data.UserMasterId);
      return user ? (user.Email || user.Contact || 'N/A') : 'N/A';
    } else if (data.UserType === 'Customer') {
      const customer = this.CustomerList.find(c => c.CustomerId === data.UserMasterId);
      return customer ? (customer.CustomerContactNumber || 'N/A') : 'N/A';
    }
    return 'N/A';
  }



  // Helper method to get selected notification type name for display
  getSelectedNotificationTypeName(): string {
    const formValue = this.validateForm.get('NotificationType')?.value;
    if (formValue && this.SelectedConfiguration) {
      return this.SelectedConfiguration.DisplayName || formValue;
    }
    return formValue || '';
  }

  // Schedule Management Methods

  // Get CRON description for display
  getCronDescription(cronExpression: string): string {
    try {
      if (cronExpression) {
        return cronstrue.toString(cronExpression);
      }
      return '';
    } catch (error) {
      return 'Invalid CRON expression';
    }
  }

  // Get schedule status color for display
  getScheduleStatusColor(schedule: NotificationReportScheduleMapping | NotificationReportScheduleMappingDetails): string {
    if (schedule.IsActive && !schedule.Disabled) {
      return 'green';
    } else if (schedule.Disabled) {
      return 'red';
    } else {
      return 'orange';
    }
  }

  // Get schedule status text for display
  getScheduleStatusText(schedule: NotificationReportScheduleMapping | NotificationReportScheduleMappingDetails): string {
    if (schedule.IsActive && !schedule.Disabled) {
      return 'Active';
    } else if (schedule.Disabled) {
      return 'Disabled';
    } else {
      return 'Inactive';
    }
  }

  // Get count of active schedules
  getActiveSchedulesCount(): number {
    if (!this.selectedNotificationGroupDetails?.NotificationReportScheduleMappings) {
      return 0;
    }
    return this.selectedNotificationGroupDetails.NotificationReportScheduleMappings.filter(
      s => s.IsActive && !s.Disabled
    ).length;
  }

  // Get count of disabled schedules
  getDisabledSchedulesCount(): number {
    if (!this.selectedNotificationGroupDetails?.NotificationReportScheduleMappings) {
      return 0;
    }
    return this.selectedNotificationGroupDetails.NotificationReportScheduleMappings.filter(
      s => s.Disabled || !s.IsActive
    ).length;
  }

  // Get total count of schedules
  getTotalSchedulesCount(): number {
    if (!this.selectedNotificationGroupDetails?.NotificationReportScheduleMappings) {
      return 0;
    }
    return this.selectedNotificationGroupDetails.NotificationReportScheduleMappings.length;
  }

  // Toggle schedule status (enable/disable)
  toggleScheduleStatus(schedule: NotificationReportScheduleMapping | NotificationReportScheduleMappingDetails, enabled: boolean): void {
    // Set loading state
    schedule.isUpdating = true;

    // Prepare the update data
    const updateData = {
      NotificationGroupUserId: this.selectedNotificationGroup?.NotificationGroupUserId || this.selectedNotificationGroupDetails?.NotificationGroupUserId,
      ReportId: schedule.ReportId,
      IsActive: enabled,
      Disabled: !enabled
    };

    // Call the backend to update the schedule
    this.updateScheduleStatus(updateData).then((success) => {
      if (success) {
        // Update the local data
        schedule.IsActive = enabled;
        schedule.Disabled = !enabled;

        // Show success message
        this.alertService.success(
          `Schedule ${enabled ? 'enabled' : 'disabled'} successfully`
        );

        // Check if we need to update the trigger types
        this.checkAndUpdateTriggerTypes();
      } else {
        // Revert the switch state on error
        schedule.IsActive = !enabled;
        schedule.Disabled = enabled;
      }

      // Remove loading state
      schedule.isUpdating = false;
    });
  }

  // Update schedule status via API
  private updateScheduleStatus(updateData: any): Promise<boolean> {
    return new Promise((resolve) => {
      const url = this.ApiUrl + "notificationconfig/updatenotificationschedule";

      this.http.post<any>(url, updateData).subscribe({
        next: (_) => {
          resolve(true);
        },
        error: (error) => {
          console.error('Error updating schedule status:', error);
          this.alertService.error('Failed to update schedule status. Please try again.');
          resolve(false);
        }
      });
    });
  }

  // Check if trigger types need to be updated based on active schedules
  private checkAndUpdateTriggerTypes(): void {
    if (!this.selectedNotificationGroup?.NotificationReportScheduleMappings) {
      return;
    }

    const hasActiveSchedules = this.selectedNotificationGroup.NotificationReportScheduleMappings.some(
      s => s.IsActive && !s.Disabled
    );

    let currentTriggerTypes: string[] = [];

    // Parse current trigger types
    if (Array.isArray(this.selectedNotificationGroup.TriggerType)) {
      currentTriggerTypes = [...this.selectedNotificationGroup.TriggerType];
    } else if (typeof this.selectedNotificationGroup.TriggerType === 'string') {
      try {
        if (this.selectedNotificationGroup.TriggerType.startsWith('[')) {
          currentTriggerTypes = JSON.parse(this.selectedNotificationGroup.TriggerType);
        } else {
          currentTriggerTypes = [this.selectedNotificationGroup.TriggerType];
        }
      } catch {
        currentTriggerTypes = [this.selectedNotificationGroup.TriggerType || 'Event'];
      }
    }

    const hasScheduledTrigger = currentTriggerTypes.includes('Scheduled');

    // Update trigger types if needed
    if (!hasActiveSchedules && hasScheduledTrigger) {
      // Remove "Scheduled" trigger type if no active schedules
      currentTriggerTypes = currentTriggerTypes.filter(t => t !== 'Scheduled');
      this.updateNotificationGroupTriggerTypes(currentTriggerTypes);
    } else if (hasActiveSchedules && !hasScheduledTrigger) {
      // Add "Scheduled" trigger type if there are active schedules
      currentTriggerTypes.push('Scheduled');
      this.updateNotificationGroupTriggerTypes(currentTriggerTypes);
    }
  }

  // Update notification group trigger types
  private updateNotificationGroupTriggerTypes(triggerTypes: string[]): void {
    const updateData = {
      ...this.selectedNotificationGroup,
      TriggerType: triggerTypes
    };

    const url = this.ApiUrl + "notificationconfig/notificationgroupupdate";

    this.http.post<any>(url, updateData).subscribe({
      next: (_) => {
        // Update local data
        this.selectedNotificationGroup.TriggerType = triggerTypes;

        // Refresh the notification group list
        this.GetAllNotificationsGroup();

        this.alertService.success('Trigger types updated automatically based on active schedules');
      },
      error: (error) => {
        console.error('Error updating trigger types:', error);
        this.alertService.warning('Schedule updated but failed to update trigger types automatically');
      }
    });
  }



  GetAllWhatsAppTemplateList() {
    let url = this.ApiUrl + "notificationconfig/getwhatsapptemplate";
    this.http.get<WhatsAppTemplateList[]>(url).subscribe({
      next: (res) => {
        this.WhatsAppTemplateList = res;
      },
      error: (_) => {
        this.count++;
        if (this.count < 2) {
          this.GetAllWhatsAppTemplateList();
        }
      }
    });
  }

  // Broadcast push notification methods
  showBroadcastModal() {
    this.broadcastRequest = new BroadcastPushNotificationRequest();
    this.isBroadcastModalVisible = true;
    this.getPushEnabledUsers();
  }

  closeBroadcastModal() {
    this.isBroadcastModalVisible = false;
    this.broadcastRequest = new BroadcastPushNotificationRequest();
  }

  getPushEnabledUsers() {
    let url = this.ApiUrl + "notificationconfig/getpushenabledusers";
    this.http.get<PushEnabledUser[]>(url).subscribe({
      next: (res) => {
        this.pushEnabledUsers = res;
      },
      error: (_) => {
        this.count_broadcast++;
        if (this.count_broadcast < 2) {
          this.getPushEnabledUsers();
        }
      }
    });
  }

  sendBroadcastNotification() {
    // Validate required fields
    if (!this.broadcastRequest.UserMasterIds || this.broadcastRequest.UserMasterIds.length === 0) {
      this.alertService.error('Please select at least one user');
      return;
    }
    if (!this.broadcastRequest.Title || this.broadcastRequest.Title.trim() === '') {
      this.alertService.error('Please enter a notification title');
      return;
    }
    if (!this.broadcastRequest.Body || this.broadcastRequest.Body.trim() === '') {
      this.alertService.error('Please enter a notification message');
      return;
    }

    this.isSendingBroadcast = true;
    let url = this.ApiUrl + "notificationprocessor/sendbroadcastpushnotification";
    this.http.post<any>(url, this.broadcastRequest).subscribe({
      next: (res) => {
        this.isSendingBroadcast = false;
        if (res.Success) {
          this.alertService.success(res.Message || 'Broadcast push notification sent successfully');
          this.closeBroadcastModal();
        } else {
          this.alertService.error(res.Message || 'Failed to send broadcast push notification');
        }
      },
      error: (err) => {
        this.isSendingBroadcast = false;
        this.count_broadcast++;
        if (this.count_broadcast < 2) {
          this.sendBroadcastNotification();
        } else {
          this.alertService.error('Failed to send broadcast push notification. Please try again.');
        }
      }
    });
  }
}
